import { Pipe, PipeTransform } from '@angular/core';
import { REQUEST_ACTION } from 'src/app/core/constants/request-action.enum';

@Pipe({
    name: 'RequestActionName'
})
export class RequestActionNamePipe implements PipeTransform {
    transform(action: any): any {
        switch (action) {
            case REQUEST_ACTION.OPERATION_ASSIGN:
                return 'operationAssign';
            case REQUEST_ACTION.OPERATION_REASSIGN:
                return 'operationReassign';
            case REQUEST_ACTION.CLOSE:
                return 'close';
            case REQUEST_ACTION.RETURN:
                return 'return';
            case REQUEST_ACTION.REVOKE:
                return 'revoke';
            case REQUEST_ACTION.OPERATION_COMPLETE:
                return 'operationComplete';
            case REQUEST_ACTION.OPEN:
                return 'open';
            case REQUEST_ACTION.ASSIGN:
                return 'assign';
            case REQUEST_ACTION.OPERATION_OPEN:
                return 'operationOpen';
            default:
                return 'assign';
        }
    }
}
